import { max, min } from 'd3-array';
import { linearAxis, bandAxis } from '../../../factory/axes';
import { bandScale, ordinalScale } from '../../../factory/scales';

import data from './data/data.json';
import { cnn_red } from './utils/colors';

export default function (props) {
  const { initialWidth, isMobile } = props;

  const margins = isMobile ? {
    top: 0,
    right: 50,
    bottom: 20,
    left: 135,
  } : {
    top: 0,
    right: 100,
    bottom: 20,
    left: 200,
  };


  const barHeight = isMobile ? 24 : 27;
  const padding = 0.15;
  const keys = Object.keys(data[0]).slice(5);

  const width = initialWidth - margins.right - margins.left;
  const height = (data.length * keys.length) * (barHeight + (padding * barHeight));

  // const maxValue = max(data, d => max(keys, key => d[key]));
  const maxValue = 100e6;// max(data, d => max(keys, key => d[key]));
  const minValue = min(data, d => min(keys, key => d[key]));

  const xAxisConfig = {
    orientation: 'bottom',
    domain: [Math.min(0, minValue), maxValue],
    range: [0, width],
    nice: true,
  };

  const yAxisConfig = {
    orientation: 'left',
    domain: data.map(d => d.committee),
    range: [0, height],
    padding,
  };

  const { axis: xAxis, scale: x } = linearAxis(xAxisConfig);
  const { axis: yAxis, scale: y0 } = bandAxis(yAxisConfig);

  const y1 = bandScale({
    domain: keys,
    range: [0, y0.bandwidth()],
    padding,
  });

  const colorScale = ordinalScale({
    domain: keys,
    range: cnn_red[keys.length - 1],
  });

  return {
    colorScale,
    data,
    height,
    initialWidth,
    initialHeight: height + margins.top + margins.bottom,
    keys,
    margins,
    width,
    xAxis,
    x,
    yAxis,
    y0,
    y1,
  };
}
